import { Component, type ReactNode } from 'react'

// Catches render-time errors (e.g. a chart choking on malformed data) so one bad
// view never blanks the whole app.
export default class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="rounded-lg border border-dashed border-oxblood/20 bg-blush/20 px-6 py-12 text-center">
          <p className="font-display text-lg text-oxblood/80">Something went wrong on this screen</p>
          <p className="mx-auto mt-2 max-w-md font-body text-sm text-ink/50">{this.state.error.message}</p>
          <button onClick={() => this.setState({ error: null })}
            className="mt-4 rounded-md border border-oxblood/25 px-4 py-1.5 font-body text-sm text-oxblood hover:bg-oxblood/5">
            Try again
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
